import React, { Component } from 'react';
import { translate } from 'react-i18next';

class Password extends Component {

  render() {
    const { t } = this.props;
    return (
      <form className="form-horizontal" method="post" onSubmit={this.props.handlePasswordSubmit}>
        <fieldset>
          <div className="panel panel-default">
            <div className="panel-heading">
              <h4 className="panel-title">{t('guest.password.heading_password')}</h4>
            </div>
            <div className="panel-body">
              <p>{t('guest.password.security')}</p>
              <hr />
              <div className="form-group">
                <label className="col-sm-3 control-label" htmlFor="password">
                  {t('guest.password.label_password')}
                </label>
                <ul>
                  <li>La contraseña debe tener al menos una mayúscula</li>
                  <li>La contraseña debe tener al menos una miniscula</li>
                  <li>La contraseña debe tener al menos un numero</li>
                  <li>La contraseña debe tener al menos un caracter especial</li>
                  <li>La contraseña debe tener al menos 8 caracteres</li>
                </ul>
                <div className="col-sm-7">
                  <input
                    className="form-control"
                    id="password"
                    onChange={this.props.handlePasswordChange}
                    required
                    type="password"
                    value={this.props.password} />
                </div>
              </div>
              <div className="form-group">
                <label className="col-sm-3 control-label" htmlFor="passwordConfirm">
                  {t('guest.password.label_pwdconfirm')}
                </label>
                <div className="col-sm-7">
                  <input
                    className="form-control"
                    id="passwordConfirm"
                    onChange={this.props.handlePasswordConfirm}
                    required
                    type="password"
                    value={this.props.passwordConfirm} />
                </div>
              </div>
              <div className={this.props.error ? "" : "hidden"}>
                <div className="form-group">
                  <div className="col-sm-3" />
                  <div className="col-sm-7">
                    <div className="alert alert-warning">
                      <i className="glyphicon glyphicon-remove pull-right" onClick={this.props.handleClearError} />
                      {this.props.error}
                    </div>
                  </div>
                </div>
              </div>
              <div className="form-group">
                <div className="col-sm-3" />
                <div className="col-sm-7">
                  <button
                    className="btn btn-primary"
                    type="submit">
                    {t('guest.password.btn_submit')}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </fieldset>
      </form>
    );
  }
}

export default translate('common')(Password);



// WEBPACK FOOTER //
// ./src/guest/password/Password.js